export default __webpack_public_path__ + "static/media/props-context.da50f83e.png";